import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const CultureIndex = () => {
    const navigate = useNavigate();

    // Configuração de filtros
    const filterConfig = useMemo(() => [
        {
            type: "text",
            name: "description",
            label: "Description",
            placeholder: "Search by description..."
        }
    ], []);

    // Colunas da tabela
    const columns = useMemo(() => [
        { 
            title: 'Description', 
            dataIndex: 'description', 
            key: 'description', 
            sortable: true 
        },
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: 100,
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, handleToggleActive, handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    // Actions
    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/culture/edit/${record.cultureID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="Culture"
            apiEndpoint="/Culture/getAllPaginated"
            toggleActiveEndpoint="/Culture/toggleActive"
            toggleDeletedEndpoint="/Culture/toggleDeleted"
            newRoute="/culture/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="cultureID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default CultureIndex;
